import React from 'react';
import { Box, Flex, Radio, RadioGroup, Text, Badge } from '@chakra-ui/react';
import { STATUS_LABEL } from './constants';
import dayjs from 'dayjs';

function fmtDate(iso) {
  if (!iso) return '';
  const d = dayjs(iso);
  return d.isValid() ? d.format('DD-MM-YYYY') : '';
}

/**
 * Radios de matrículas candidatas. Cuando hay 1 sola, no interactivo (chip
 * informativo). Cuando hay 2+, radios en columna con badge "Sugerida por
 * fecha" en la que la heurística eligió.
 */
export default function MatriculaSelector({
  enrollments,
  selectedId,
  suggestedId,
  onSelect,
  disabled,
}) {
  if (!enrollments || enrollments.length === 0) {
    return (
      <Box borderWidth="1px" borderColor="orange.200" bg="orange.50" borderRadius="md" p={3}>
        <Text fontSize="xs" color="orange.700">
          No hay matrículas candidatas para este pago.
        </Text>
      </Box>
    );
  }

  if (enrollments.length === 1) {
    const e = enrollments[0];
    return (
      <Box borderWidth="1px" borderColor="purple.100" bg="purple.50" borderRadius="md" p={2.5}>
        <Text fontSize="xs" color="purple.700" fontWeight="600">
          Matrícula #{e.id}
          {e.semesterName ? ` · ${e.semesterName}` : ''}
          {e.status ? ` · ${STATUS_LABEL[e.status] || e.status}` : ''}
          {e.createdAt ? ` · creada ${fmtDate(e.createdAt)}` : ''}
        </Text>
      </Box>
    );
  }

  return (
    <RadioGroup
      value={String(selectedId ?? '')}
      onChange={(val) => onSelect(Number(val))}
      isDisabled={disabled}
    >
      <Flex direction="column" gap={2}>
        {enrollments.map((e) => (
          <Box
            key={e.id}
            borderWidth="1px"
            borderColor={selectedId === e.id ? 'purple.200' : 'gray.200'}
            bg={selectedId === e.id ? 'purple.50' : 'white'}
            borderRadius="md"
            p={2.5}
          >
            <Radio value={String(e.id)}>
              <Flex align="center" gap={2} flexWrap="wrap">
                <Text fontSize="xs" fontWeight="600" color="gray.800">
                  Matrícula #{e.id}
                </Text>
                {e.semesterName && (
                  <Text fontSize="xs" color="gray.600">
                    · {e.semesterName}
                  </Text>
                )}
                {e.status && (
                  <Text fontSize="xs" color="gray.500">
                    · {STATUS_LABEL[e.status] || e.status}
                  </Text>
                )}
                {e.createdAt && (
                  <Text fontSize="xs" color="gray.500">
                    · creada {fmtDate(e.createdAt)}
                  </Text>
                )}
                {suggestedId === e.id && (
                  <Badge colorScheme="purple" fontSize="10px" px={2} py={0} borderRadius="4px">
                    Sugerida por fecha
                  </Badge>
                )}
              </Flex>
            </Radio>
          </Box>
        ))}
      </Flex>
    </RadioGroup>
  );
}
